import React, { useEffect } from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { FaGraduationCap, FaChalkboardTeacher, FaUsers, FaLaptopCode, FaQuoteLeft, FaAward, FaHandshake } from 'react-icons/fa';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';
import './About.css';

const About: React.FC = () => {
  useEffect(() => {
    // تمرير إلى أعلى الصفحة عند التحميل
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Header />
      <div className="page-container about-page bg-light">
        <div className="hero-section text-white py-5 mb-5">
          <Container>
            <Row className="justify-content-center text-center">
              <Col md={8} className="fade-in">
                <h1 className="display-4 fw-bold mb-4">من نحن</h1>
                <p className="lead mb-4">
                  منصة السامي التعليمية هي منصة رائدة في مجال التعليم الإلكتروني، تهدف إلى توفير تجربة تعليمية متميزة وفعالة للطلاب والمعلمين.
                </p>
              </Col>
            </Row>
          </Container>
        </div>

        <Container className="py-5">
          <Row className="mb-5">
            <Col lg={6} className="mb-4 mb-lg-0 fade-in-right delay-1">
              <div className="section-title">
                <h2 className="fw-bold mb-4">رؤيتنا</h2>
              </div>
              <p className="lead">
                نسعى لأن نكون المنصة التعليمية الرائدة في العالم العربي، من خلال توفير محتوى تعليمي عالي الجودة يساهم في تطوير مهارات الطلاب وتحقيق طموحاتهم.
              </p>
              <p>
                نؤمن بأن التعليم حق للجميع، ونعمل على توفير فرص تعليمية متكافئة لجميع الطلاب بغض النظر عن مواقعهم الجغرافية أو ظروفهم الاقتصادية.
              </p>
              <div className="mt-4 p-4 bg-white rounded shadow-sm fade-in-up delay-2">
                <FaQuoteLeft className="text-primary mb-3" size={30} />
                <p className="fst-italic">
                  "التعليم هو السلاح الأقوى الذي يمكنك استخدامه لتغيير العالم."
                </p>
                <p className="text-end mb-0 fw-bold">- نيلسون مانديلا</p>
              </div>
            </Col>
            <Col lg={6} className="fade-in-left delay-1">
              <div className="section-title">
                <h2 className="fw-bold mb-4">رسالتنا</h2>
              </div>
              <p className="lead">
                تمكين الطلاب والمعلمين من خلال توفير منصة تعليمية تفاعلية وسهلة الاستخدام، تجمع بين التكنولوجيا الحديثة وأفضل الممارسات التعليمية.
              </p>
              <p>
                نسعى لتحقيق ذلك من خلال توفير محتوى تعليمي متنوع وعالي الجودة، وأدوات تفاعلية تساعد على تحسين تجربة التعلم وزيادة فعاليتها.
              </p>
              <div className="d-flex flex-wrap mt-4">
                <div className="d-flex align-items-center mb-3 me-4 fade-in-up delay-2">
                  <div className="bg-primary rounded-circle p-2 me-2">
                    <FaAward className="text-white" />
                  </div>
                  <span>محتوى تعليمي معتمد</span>
                </div>
                <div className="d-flex align-items-center mb-3 me-4 fade-in-up delay-3">
                  <div className="bg-primary rounded-circle p-2 me-2">
                    <FaHandshake className="text-white" />
                  </div>
                  <span>دعم مستمر للطلاب</span>
                </div>
              </div>
            </Col>
          </Row>

          <Row className="mb-5">
            <Col>
              <div className="text-center mb-5 fade-in">
                <div className="section-title d-inline-block">
                  <h2 className="fw-bold mb-4">قيمنا</h2>
                </div>
                <p className="lead mx-auto" style={{ maxWidth: '700px' }}>
                  نلتزم بمجموعة من القيم الأساسية التي توجه عملنا وتساعدنا على تحقيق رؤيتنا ورسالتنا
                </p>
              </div>
              <Row>
                <Col md={6} lg={3} className="mb-4 fade-in-up delay-1">
                  <Card className="value-card h-100 border-0 shadow-sm">
                    <Card.Body className="text-center p-4">
                      <div className="icon-wrapper mb-3">
                        <FaGraduationCap className="text-primary" size={40} />
                      </div>
                      <Card.Title className="fw-bold">الجودة</Card.Title>
                      <Card.Text>
                        نلتزم بتقديم محتوى تعليمي عالي الجودة يتوافق مع المعايير العالمية ويلبي احتياجات الطلاب.
                      </Card.Text>
                    </Card.Body>
                  </Card>
                </Col>
                <Col md={6} lg={3} className="mb-4 fade-in-up delay-2">
                  <Card className="value-card h-100 border-0 shadow-sm">
                    <Card.Body className="text-center p-4">
                      <div className="icon-wrapper mb-3">
                        <FaChalkboardTeacher className="text-primary" size={40} />
                      </div>
                      <Card.Title className="fw-bold">الابتكار</Card.Title>
                      <Card.Text>
                        نسعى دائمًا لتطوير منصتنا وتحسين تجربة المستخدم من خلال تبني أحدث التقنيات والأساليب التعليمية.
                      </Card.Text>
                    </Card.Body>
                  </Card>
                </Col>
                <Col md={6} lg={3} className="mb-4 fade-in-up delay-3">
                  <Card className="value-card h-100 border-0 shadow-sm">
                    <Card.Body className="text-center p-4">
                      <div className="icon-wrapper mb-3">
                        <FaUsers className="text-primary" size={40} />
                      </div>
                      <Card.Title className="fw-bold">التعاون</Card.Title>
                      <Card.Text>
                        نؤمن بأهمية التعاون بين الطلاب والمعلمين، ونعمل على توفير بيئة تعليمية تشجع على المشاركة والتفاعل.
                      </Card.Text>
                    </Card.Body>
                  </Card>
                </Col>
                <Col md={6} lg={3} className="mb-4 fade-in-up delay-4">
                  <Card className="value-card h-100 border-0 shadow-sm">
                    <Card.Body className="text-center p-4">
                      <div className="icon-wrapper mb-3">
                        <FaLaptopCode className="text-primary" size={40} />
                      </div>
                      <Card.Title className="fw-bold">التطوير المستمر</Card.Title>
                      <Card.Text>
                        نلتزم بالتطوير المستمر لمنصتنا ومحتواها التعليمي، لضمان تقديم أفضل تجربة تعليمية ممكنة.
                      </Card.Text>
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
            </Col>
          </Row>

          <Row>
            <Col>
              <div className="text-center mb-5 fade-in">
                <div className="section-title d-inline-block">
                  <h2 className="fw-bold mb-4">فريقنا</h2>
                </div>
                <p className="lead mx-auto" style={{ maxWidth: '700px' }}>
                  يتكون فريقنا من نخبة من المعلمين والخبراء في مجال التعليم والتكنولوجيا، يعملون معًا لتوفير تجربة تعليمية متميزة.
                </p>
              </div>
              <Row className="justify-content-center">
                <Col md={6} lg={4} className="mb-4 fade-in-up delay-1">
                  <Card className="team-card border-0 shadow-sm">
                    <Card.Body className="text-center p-4">
                      <div className="team-img-container mx-auto mb-3">
                        <img 
                          src="https://via.placeholder.com/120" 
                          alt="صورة عضو الفريق" 
                          className="img-fluid"
                        />
                      </div>
                      <Card.Title className="fw-bold">أحمد السامي</Card.Title>
                      <Card.Subtitle className="mb-3 text-muted">المؤسس والرئيس التنفيذي</Card.Subtitle>
                      <Card.Text>
                        خبير في مجال التعليم الإلكتروني، يمتلك خبرة أكثر من 10 سنوات في تطوير المنصات التعليمية.
                      </Card.Text>
                    </Card.Body>
                  </Card>
                </Col>
                <Col md={6} lg={4} className="mb-4 fade-in-up delay-2">
                  <Card className="team-card border-0 shadow-sm">
                    <Card.Body className="text-center p-4">
                      <div className="team-img-container mx-auto mb-3">
                        <img 
                          src="https://via.placeholder.com/120" 
                          alt="صورة عضو الفريق" 
                          className="img-fluid"
                        />
                      </div>
                      <Card.Title className="fw-bold">سارة محمد</Card.Title>
                      <Card.Subtitle className="mb-3 text-muted">مديرة المحتوى التعليمي</Card.Subtitle>
                      <Card.Text>
                        متخصصة في تطوير المناهج التعليمية، تعمل على ضمان جودة المحتوى التعليمي وتطويره بشكل مستمر.
                      </Card.Text>
                    </Card.Body>
                  </Card>
                </Col>
                <Col md={6} lg={4} className="mb-4 fade-in-up delay-3">
                  <Card className="team-card border-0 shadow-sm">
                    <Card.Body className="text-center p-4">
                      <div className="team-img-container mx-auto mb-3">
                        <img 
                          src="https://via.placeholder.com/120" 
                          alt="صورة عضو الفريق" 
                          className="img-fluid"
                        />
                      </div>
                      <Card.Title className="fw-bold">محمد خالد</Card.Title>
                      <Card.Subtitle className="mb-3 text-muted">مدير التكنولوجيا</Card.Subtitle>
                      <Card.Text>
                        مهندس برمجيات ذو خبرة واسعة في تطوير المنصات التعليمية، يعمل على تطوير وتحسين منصة السامي.
                      </Card.Text>
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default About;
